export const ASSISTANT_TEMPLATE_SOURCE_MAX_CHARACTERS = 64_000;
